import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["functionalareaSelect", "positioncategorySelect", "tagSelect", "expertiseSelect"]

  connect() {
    this.element.querySelectorAll("[data-search-empty-disabled]").forEach(input => {
      input.disabled = false
      delete input.dataset.searchEmptyDisabled
    })
  }

  clearEmptyParams(event) {
    const inputs = this.element.querySelectorAll("input, select")
    inputs.forEach(input => {
      if (input.value === "") {
        if (!input.disabled) {
          input.dataset.searchEmptyDisabled = "true"
          input.disabled = true
        }
      }
    })
  }

  filterFunctionalarea() {
    this.positioncategorySelectTarget.value = ""
    this.tagSelectTarget.value = ""
    this.expertiseSelectTarget.value = ""
    this.element.requestSubmit()
  }

  filterTag() {
    this.expertiseSelectTarget.value = ""
    this.element.requestSubmit()
  }

  changeFunctionalarea(event) {

    const functionalareaId = event.target.value
    if (!functionalareaId) return this.clearOptions()

    fetch(`/functionalareas/${functionalareaId}/dependent_options`)
      .then(response => response.json())
      .then(data => {
        this.updateSelect(this.positioncategorySelectTarget, data.positioncategories)
        this.updateSelect(this.tagSelectTarget, data.tags)
      })
  }

  updateSelect(selectElement, items) {
    selectElement.innerHTML = ""
    // optional: Standard-Prompt
    const promptOption = document.createElement("option")
    promptOption.value = ""
    promptOption.textContent = selectElement.dataset.prompt || "Bitte wählen"
    selectElement.appendChild(promptOption)

    items.forEach(item => {
      const option = document.createElement("option")
      option.value = item.id
      option.textContent = item.label
      selectElement.appendChild(option)
    })
  }

  clearOptions() {
    this.updateSelect(this.positioncategorySelectTarget, [])
    this.updateSelect(this.tagSelectTarget, [])
  }
}